import { useState } from "react";

import { useLoaderData } from "@remix-run/react";

import KonnectButton from "~/components/common/KonnectButton/KonnectButton";
import type { LandingPageLoader } from "~/routes/_pages._index";

import Faq from "../Faq/Faq";

const FaqsSection = () => {
  const { faqs } = useLoaderData<LandingPageLoader>();
  const [seeAll, setSeeAll] = useState(false);
  const [activeFaq, setActiveFaq] = useState<string | null>(null);

  const displayedFaqs = seeAll ? faqs : faqs.slice(0, 7);

  return (
    <section
      id="faqs-section"
      className="section-padding-x-large pt-[80px] md:pt-[120px]"
    >
      <h2 className="h2 mb-[30px] text-center font-semibold md:mb-[60px]">
        FAQ's
      </h2>
      <div
        id="accordion-flush"
        data-accordion="collapse"
        className={`relative ${
          !seeAll
            ? 'after:absolute after:bottom-0 after:h-[100px] after:w-full after:bg-gradient-to-b after:from-[#F9F8FF]/10 after:to-[#F9F8FF] after:content-["_"]'
            : ""
        }`}
      >
        {displayedFaqs.map((faq) => (
          <Faq
            key={faq.id}
            isOpen={activeFaq === faq.id}
            {...faq}
            onClick={() => {
              if (activeFaq === faq.id) {
                setActiveFaq(null);
              } else {
                setActiveFaq(faq.id);
              }
            }}
          />
        ))}
      </div>
      <div className="flex justify-center">
        <KonnectButton
          bgColor="transparent"
          hoverBgColor="transparent"
          textColor="purple"
          hoverTextColor="charcoal"
          onClick={() => setSeeAll(!seeAll)}
          text={seeAll ? "View less FAQ’s" : "View more FAQ’s"}
          icon={true}
          className="mt-[50px]"
        />
      </div>
    </section>
  );
};

export default FaqsSection;
